import { isProductionBuild } from '@cdc-internal/fe-toolbox/utils/env'
import { devtools } from 'zustand/middleware'

// Allow using Redux DevTools to inspect Zustand stores in development environment
// https://github.com/pmndrs/zustand/discussions/842#discussioncomment-2288033
export const devtoolsInNonProd = (isProductionBuild
  ? (fn: any) => fn
  : devtools) as unknown as typeof devtools
